import React from "react";
import { UserAvatarProps } from "../types";
import { StyledIconButton } from "./styled";
import Avatar from "../../../components/Avatar";
import pallet from "../../../layouts/pallet";

const UserAvatar = ({ profile, name, onClick }: UserAvatarProps) => {
  return (
    <StyledIconButton onClick={onClick}>
      <Avatar
        src={profile || ""}
        height="26"
        width="26"
        variant="circular"
        alt={name || ""}
        style={{ backgroundColor: pallet.filtersChipBorder }}
      />
    </StyledIconButton>
  );
};

export default UserAvatar;
